import { render, staticRenderFns } from "./AdminTireCatalog.vue?vue&type=template&id=acc3df78&scoped=true"
import script from "./AdminTireCatalog.vue?vue&type=script&lang=js"
export * from "./AdminTireCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc3df78",
  null
  
)

export default component.exports